import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cake, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const BirthdayCountdown = () => {
  const { user } = useAuth();
  const [days, setDays] = useState(null);

  useEffect(() => {
    if (!user || !user.dob) { setDays(null); return; }
    api.get("/me/twins").then((r) => setDays(r.data.has_dob ? r.data.days_until : null)).catch(() => setDays(null));
  }, [user]);

  if (days == null || days <= 1) return null;

  return (
    <Link to="/birthdays" data-testid="birthday-countdown" className="group flex items-center gap-3 bg-ink text-white rounded-xl px-5 py-3 mt-4 max-w-2xl hover:bg-[#1f2937] transition-colors">
      <span className="w-9 h-9 rounded-full bg-gold text-ink flex items-center justify-center shrink-0"><Cake className="w-4 h-4" /></span>
      <span className="text-[14px] leading-snug">
        <strong className="text-gold" data-testid="birthday-countdown-days">{days} days</strong> until your birthday — <span className="underline decoration-gold/60 group-hover:decoration-gold">preview your twins</span>
      </span>
      <ArrowRight className="w-4 h-4 ml-auto text-gold shrink-0 transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
};
